import { call } from "redux-saga/effects";
import { APIS } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* searchLottery(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.LOTTERY.SEARCH, action.payload, true);
}

export function* lotteryDetails(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.LOTTERY.DETAILS + action.payload, null, true);
}

export function* addUpdateLottery(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.LOTTERY.INSERT_UPDATE, action.payload, true);
}

export function* deleteLottery(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.LOTTERY.DELETE, action.payload, true);
}

export function* ticketSearch(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.LOTTERY.TICKET_SEARCH, action.payload, true);
}

export function* ticketExport(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.LOTTERY.TICKET_EXPORT, action.payload, true, undefined);
}

export function* bookletDelete(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.LOTTERY.BOOKLET_DELETE, action.payload, true);
}

export function* checkBookletUnique(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.LOTTERY.CHECK_BOOKLET_UNIQUE, action.payload, true);
}

export function* lookupBarcode(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.LOTTERY.LOOKUP_BARCODE, action.payload, true);
}

export function* bookletParsedAdd(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.LOTTERY.BOOKLET_PARSED_ADD, action.payload, true);
}
